import * as questionIds from "../../consultationQuestions/questionIds";

export const otherQuestions = [
    {
        id: questionIds.OtherNotes,
        questionText: "Notes",
    },
    {
        id: questionIds.OtherAttachments,
        questionText: "Attachments",
    }
];
